import type {
  Cluster,
  MarkerClustererOptions,
  Renderer,
} from '@googlemaps/markerclusterer';
import { SuperClusterAlgorithm } from '@googlemaps/markerclusterer';

import type {
  ClusterOptions,
  Marker,
  MarkerEventTriggers,
  MarkerListeners,
} from '../../maps';
import type {
  AdvancedMarkerEventListener,
  ClusterMarkerFactory,
} from '../types';

export function addAdvancedMarkerEventListeners(
  advancedMarker: google.maps.marker.AdvancedMarkerElement,
  marker: Marker,
  markerListeners?: MarkerListeners
): AdvancedMarkerEventListener[] {
  // NOTE It is needed to set a listener to make the element interactive for the next EventListeners
  advancedMarker.addListener('gmp-click', () => {
    /**/
  });
  const listeners: AdvancedMarkerEventListener[] = [];
  for (const listener in markerListeners) {
    const callback = (): void =>
      markerListeners[listener as MarkerEventTriggers]?.(marker);
    listeners.push({ type: listener, callback: callback });

    advancedMarker.content?.addEventListener(listener, callback);
  }

  return listeners;
}

export function createGoogleMarkerClusterOptions(
  map: google.maps.Map,
  marker: Marker,
  clusterMarkerFactory: ClusterMarkerFactory,
  clusterOptions?: ClusterOptions
): MarkerClustererOptions {
  const renderer: Renderer = {
    render: (cluster: Cluster): google.maps.marker.AdvancedMarkerElement =>
      clusterMarkerFactory(marker, cluster, cluster.position),
  };

  const algorithmOptions = {
    radius: clusterOptions?.radius,
    minPoints: clusterOptions?.minPoints,
  };

  const algorithm = new SuperClusterAlgorithm(algorithmOptions);

  return {
    map,
    algorithm,
    renderer,
  };
}
